<template>
  <div class="PCHomeTab3">

    <vue-lazy-component tagName="div" :timeout="1000">
      <!-- <YourFamilyPlaymate /> -->
      <div class="title-text-box">
        <div class="describe">
          EBO X uses Alexa Voice Control to interact, and Harman AudioEFX to play beautiful music for the whole house. 
          Its lovely design, agile movement, and exciting light effects provide fun for the whole family.
        </div>
      </div>
    </vue-lazy-component>
    <vue-lazy-component tagName="div" :timeout="2000">
      <ThreeControlModes />
      <HarmanAudioEFX />
    </vue-lazy-component>
    <vue-lazy-component tagName="div" :timeout="4000">
      <BringAlexaToYou />
      <PhotoVideo />
      <RichLightingColors />
    </vue-lazy-component>

    <!-- <vue-lazy-component tagName="div" :timeout="3000">
      <BringAlexaToYou />
      <PhotoVideo />
      <RichLightingColors />
    </vue-lazy-component> -->
    <vue-lazy-component tagName="div" :timeout="6000">
      <div class="pc_aboutPrivacy-wrap">
        <img class="pc_aboutPrivacy-img" src="https://mediakit.enabot.com/eboX/img/pc/pc_aboutPrivacy@2x.png" alt="">
      </div>
      <div class="pc_aboutPrivacy-text">
        We designed EBO X with privacy protection at the forefront of our mind. Hence, all content can be optionally stored on a memory card only. 
        There are 3 simple ways to engage privacy on the EBO X.
      </div>
      <div style="marginTop:116px"> 
        <AboutPrivacyThreeImg />
      </div>
      <div class="pc_aboutPrivacy-text2">
        EBO X was created for the home — the place where families bond, grow and connect together. 
        Stay tuned: there are more interesting functions for you to discover. 
      </div>
    </vue-lazy-component>
  </div>
</template>

<script>



import YourFamilyPlaymate from './yourFamilyPlaymate'
import ThreeControlModes from './threeControlModes'
import HarmanAudioEFX from './harmanAudioEFX'
import BringAlexaToYou from './bringAlexaToYou'
import PhotoVideo from './photoVideo'
import RichLightingColors from './richLightingColors'

import AboutPrivacyThreeImg from './aboutPrivacyThreeImg'


export default {
  components:{
    YourFamilyPlaymate,
    ThreeControlModes,
    HarmanAudioEFX,
    BringAlexaToYou,
    PhotoVideo,
    RichLightingColors,
    AboutPrivacyThreeImg
  }
}
</script>

<style lang="scss">
  .PCHomeTab3{
    // padding-bottom: 120px;
    width: 100%;
    margin: 0 auto;
    background: RGBA(4, 13, 50, 1);
    .title-text-box {
      width: 715px;
      margin: 0 auto;
      // margin-bottom: 118px;
      // margin-top: 100px;

      .describe {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
      }
    }
    .pc_aboutPrivacy-wrap{
      width: 100%;
      margin-top: 120px;
      .pc_aboutPrivacy-img{
        width: 100%;
        height: auto;
      }
    }
    .pc_aboutPrivacy-text{
      max-width: 726px;
      margin: 100px auto 0;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
    }
    .pc_aboutPrivacy-text2{
      max-width: 900px;
      margin: 100px auto 0;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
    }
  }
</style>